import type { ReactNode } from 'react'

export interface EvalWorkspaceHeaderProps {
  title: string
  description: string
  titleAccessory?: ReactNode
  actions?: ReactNode
}

export function EvalWorkspaceHeader({
  title,
  description,
  titleAccessory,
  actions,
}: EvalWorkspaceHeaderProps) {
  return (
    <header className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="min-w-0 truncate text-2xl leading-8 font-bold tracking-normal text-primary-high-contrast">
            {title}
          </h1>
          {titleAccessory}
        </div>
        <p className="mt-1 text-sm leading-5 text-neutral-low-contrast">
          {description}
        </p>
      </div>

      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      ) : null}
    </header>
  )
}
